/**
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business エラー分析ページ用のサマリーカード。ラベル・値・アクセントカラーを受け取り 1 セル分の指標を描画する。
 * @graph-connects none
 */
export function SummaryCard({
  label,
  value,
  color,
}: {
  label: string;
  value: string;
  color: string;
}) {
  return (
    <div className="card animate-fade-in-up">
      <p className="text-xs text-[var(--color-text-muted)] mb-1">{label}</p>
      <p className="text-2xl font-bold font-mono" style={{ color }}>
        {value}
      </p>
    </div>
  );
}
